import { useAtomValue } from 'jotai';

import { configAtom } from '@shared/store/slice-atoms';

export const useCheckUniqueApiSource = () => {
  const urlConfig = useAtomValue(configAtom);

  let isUnique = false;

  if (urlConfig && Object.keys(urlConfig)?.length) {
    const variationKey = Object.keys(urlConfig)[0];
    const variation = (urlConfig as Record<string, { apiSource?: string } | undefined>)[variationKey];
    isUnique = !!(variation?.apiSource === 'api-web-uae-tdra');
  }

  return isUnique;
};
